import React, { useState } from 'react';
import { Card, Badge, Dropdown } from 'react-bootstrap';
import { Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FaShareAlt, FaFacebook, FaTwitter, FaWhatsapp } from 'react-icons/fa';
import './TalentAuditionCard.css'

export const TalentAuditionCard = ({ audition }) => {
  const [showShare, setShowShare] = useState(false);


  const getResultClassName = (result) => {
    const val = String(result || 'Pending').toLowerCase();
    return `custom-result-badge badge-${val}`;
  };

  const stopOnly = (e) => e?.stopPropagation?.();

  return (
    <div className="dashboard-bms-card-outer">
      <Link to={`/audition/${audition?.id}/${audition?.urlSlug || 'details'}`} className="text-decoration-none">
        <Card className="dashboard-bms-audition-card h-100">
          <div className="dashboard-bms-image-wrapper">
            <img src={audition?.projectImageUrl} alt={audition?.projectName} className="dashboard-bms-card-image" />
            {/* <span className="dashboard-bms-verified-image-icon"><Star size={14} fill="#9da3b0" /></span> */}
          </div>
          <Card.Body>
            <h5 className="dashboard-bms-project-title">{audition?.projectName}</h5>
            <p className="text-muted small">{audition?.roleTitle}</p>
            <div className="pt-2 border-top">
              <Badge pill className={getResultClassName(audition?.result)}>
                {audition?.result || 'Pending'}
              </Badge>
            </div>
          </Card.Body>
        </Card>
      </Link>
      
      {/* Share Logic */}
      {/* <div onClick={stopOnly}>
        <Dropdown show={showShare} onToggle={setShowShare} align="end">
          <Dropdown.Toggle as="button" className="dashboard-share-toggle"><FaShareAlt size={14} /></Dropdown.Toggle>
          <Dropdown.Menu>
            <div className="d-flex gap-3 p-2">
              <a href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.origin}`} target="_blank" rel="noreferrer"><FaFacebook color="#1877F2" /></a>
              <a href={`https://twitter.com/intent/tweet`} target="_blank" rel="noreferrer"><FaTwitter color="#1DA1F2" /></a>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div> */}
    </div>
  );
};